"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mapUrl = function (category) {
    if (!category.url) {
        return {};
    }
    return { categoryPageUrl: "/" + category.url.path };
};
exports.map = function (category) {
    var baseCategory = {
        _id: category.id,
        label: category.label,
        postCount: category.postsCount,
    };
    var url = mapUrl(category);
    return tslib_1.__assign(tslib_1.__assign({}, baseCategory), url);
};
//# sourceMappingURL=mapper.js.map